import { Stats } from '@react-three/drei';
import Environment from './Environment';
import Ground from './Ground';
import { isInDebugMode } from '../../util';
import { Capacitor } from '@capacitor/core';

const SkateparkScene = ({ 
  castShadow = true,
  showGround = true 
}: { 
  castShadow: boolean;
  showGround?: boolean;
}) => {
  // FPS-Anzeige nur im Debug-Modus und nicht auf iOS anzeigen
  const showStats = isInDebugMode() && !Capacitor.getPlatform().includes('ios');
  
  return (
    <>
      {showGround && <Ground />}
      <Environment castShadow={castShadow} />
      {showStats && <Stats />}
      {/* {isInDebugMode() && <Stats />} */}

    </>
  );
};

export default SkateparkScene;
